<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="prList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search for PRC Code"
            color="green darken-2"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- <v-autocomplete
            color="green"
            v-model="OfficeID"
            item-text="OfficeDescription"
            item-value="OfficeID"
            :items="office"
            @change="initialize()"
            dense
            hide-details
            class="mt-2"
            style="max-width: 200px;"
            label="Filter by office"
          >
          </v-autocomplete> -->
          <v-btn
            v-if="$store.state.user.roleID == 5 && tabs == 0"
            color="header"
            dark
            class="ml-5"
            @click="consolidatePR()"
          >
          <v-icon class="mr-1">mdi-table-merge-cells</v-icon>
            CONSOLIDATE PR
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.DateCreated`]="{ item }">
        <span class="text-no-wrap">{{ formatDate(item.DateCreated) }}</span>
      </template>
      <template v-slot:[`item.other_actions`]="{ item }">
          <span class="text-no-wrap" v-if="item.IsCancelled == 0">
            <v-btn
                v-if="$store.state.user.roleID == 5"
                @click="rfq(item)"
                x-small
                outlined
                color="blue darken-2"
                dark
                class="mr-2"
              >
                RFQ
              </v-btn>
              <v-btn
                v-if="$store.state.user.BACaccess == 1 && item.IsCanvassed == 1"
                @click="aoq(item)"
                x-small
                outlined
                color="orange darken-2"
                dark
                class="mr-2"
              >
                AOQ
              </v-btn>

              <v-btn
                v-if="$store.state.user.roleID == 5 && item.IsCanvassed == 1"
                x-small
                outlined
                color="green darken-2"
                dark
                class="mr-2"
                @click="noa(item)"
              >
                NOA
              </v-btn>
              <v-btn
                v-if="$store.state.user.roleID == 5 && item.PSUStatusID == 7 && item.IsCanvassed == 1"
                x-small
                outlined
                color="green darken-2"
                dark
                class="mr-2"
                @click="po(item)"
              >
                PO
              </v-btn>
              <v-btn
                v-if="$store.state.user.roleID == 6 || $store.state.user.roleID == 15"
                x-small
                outlined
                color="amber accent-4"
                dark
                class="mr-2"
                @click="iar(item)"
              >
                IAR
            </v-btn>
          </span>
          <span class="red--text" v-else>
            Cancelled
          </span>
      </template>
      <!-- <template v-slot:[`item.Canvassed`]="{ item }">
          <v-icon v-if="item.isApproved == 1 && item.PRstatus == 1" color="header">mdi-check</v-icon>
        </template> -->
      <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            x-small
            outlined
            color="blue darken-2"
            dark
            class="mr-2"
            @click="viewPRC(item)"
            
          >
            VIEW
          </v-btn>
          <v-btn
            @click="print(item)"
            color="red darken-3"
            class="mr-1 white--text"
            dense
            outlined
            x-small
            v-if="item.IsCancelled == 0"
          >
            Print
          </v-btn>
      </template>
    </v-data-table>
    <prcModal :prcData="prcItem" />
    <poModal :prData="poItem" />
    <noaModal :prData="noaItem" />
    <iarModal :prData="iarItem" />
    <canvasModal :canvasData="prItem1" />
    <rfqModal :rfqData="rfqItem" />
    <cprModal :cprDialog="cprDialog" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    prcModal: () => import("./PRCViewItem"),
    poModal: () => import("./AddPO"),
    noaModal: () => import("./AddNOA"),
    iarModal: () => import("./AddOtherIAR"),
    canvasModal: () => import("./PSUCanvas"),
    rfqModal: () => import("./PSURFQ"),
    cprModal: () => import("./PSUConsolidatePR"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    dialogConfirm: false,
    OfficeID: 0,
    office: [],
    dialogLoading: false,
    dialogconfirmDelete: false,
    deleteitemid: null,
    searchText: "",
    searchTimeout: null,
    amountErr: null,
    editItemId: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    menu: false,
    menu1: false,
    formData: {
      PPMPDescription: null,
      isDBM: null,
      BudgetID: null,
      Amount: null,
    },
    addPPMPDialog: false,
    prList: [],
    budgetList: [],
    prcItem: [],
    prItem1: [],
    poItem: [],
    noaItem: [],
    iarItem: [],
    rfqItem: [],
    headers: [
      {
        text: "PRC No.",
        align: "start",
        sortable: false,
        value: "PRCCODE",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Fund Code",
        value: "FundCode",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PRC Purpose",
        value: "PRCPurpose",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Date",
        value: "DateCreated",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Codes",
        value: "PRCODES",
        width: 140,
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "",
        value: "other_actions",
        sortable: false,
        align: "center",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      // {
      //   text: "Canvassed",
      //   value: "Canvassed",
      //   sortable: false,
      //   align: "center",
      //   class: "green darken-2 white--text text-caption font-weight-bold",
      // },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        class:
          "green darken-2 white--text text-caption font-weight-bold d-flex justify-center align-center",
      },
    ],
    tabs: 0,
    cprDialog: false,
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    tabs: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  created() {
    // this.getDOD();
  },
  mounted() {
    this.eventHub.$on("closePOModal", () => {
      this.poItem = {};
      this.initialize();
    });
    this.eventHub.$on("closeNOAModal", () => {
      this.noaItem = {};
      this.initialize();
    });
    this.eventHub.$on("closePRCItemodal", () => {
      this.prcItem = {};
      this.initialize();
    });
    this.eventHub.$on("closePRItemodal1", () => {
      this.prItem1 = {};
      this.initialize();
    });
    this.eventHub.$on("closeCanvasModal", () => {
      this.initialize();
    });
    this.eventHub.$on("closeRFQModal", () => {
      this.initialize();
    });
    this.eventHub.$on("closeCPRModal", () => {
      this.cprDialog = false;
      this.initialize();
    });
    let data = new FormData();
    data.append("page", 1);
    data.append("itemsPerPage", 1000000);
    this.axiosCall("/getAllOffice", "POST", data).then((res) => {
      this.office = res.data.data.result;
      this.office.push({ OfficeID: 0, OfficeDescription: "All" });
      this.office.sort(function (a, b) {
        return a.OfficeID - b.OfficeID;
      });
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closePRCItemodal");
    this.eventHub.$off("closePRItemodal1");
    this.eventHub.$off("closeCanvasModal");
    this.eventHub.$off("closeRFQModal");
    this.eventHub.$off("closePOModal");
    this.eventHub.$off("closeNOAModal");
    this.eventHub.$off("closeCPRModal");

  },
  methods: {
    po(data) {
      this.poItem = data;
    },
    noa(data) {
      this.noaItem = data;
    },
    iar(data) {
      this.iarItem = data;
      console.log(data)
    },
    deletePR() {
      this.dialogLoading = true;
      let data = new FormData();
      data.append("PRID", this.deleteitemid);
      this.axiosCall("/pr/delete", "POST", data).then(() => {
        this.dialogLoading = false;
        this.dialogconfirmDelete = false;
        this.deleteitemid = null;
        this.initialize();
      });
    },
    deleteItem(data) {
      this.deleteitemid = data.PRID;
      if (this.deleteitemid) {
        this.dialogconfirmDelete = true;
      }
    },
    aoq(item) {
      this.prItem1 = item;
    },
    rfq(data) {
      this.rfqItem = data;
      // window.open(this.apiUrl + "/pr/rfq/" + data.PRID);
    },
    print(data) {
      window.open(this.apiUrl + "/pr/consolidated/report/" + data.PRCID);
    },
    viewPRC(item) {
      this.prcItem = item;
    },
    initialize() {
      this.loading = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("searchText", this.searchText);
      data.append("OfficeID", this.OfficeID);
      data.append("FiscalYearID", this.fiscalYear);
      if(this.$store.state.user.roleID == 5){
      data.append("tab", this.tabs);
      }
      this.axiosCall("/get/consolidated/prc", "POST", data).then((res) => {
        this.loading = false;
        this.prList = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    consolidatePR(){
      this.cprDialog = true;
    }
  },
};
</script>